/**
 * Created by mzhao on 01/05/2023.
 * Description:
 * ConfirmSendDialog Component
 * ------ maintenance history ------
 */
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ElementRef } from '@angular/core';
import { catchError, filter, take } from 'rxjs/operators';
import { of, Subscription } from 'rxjs';
import { usersAndTeamsSelector } from '../../../redux/reducers/users.reducer';
import { StoreQuerierService } from '../../../services/store-querier.service';
import { ConfirmSendDialogService } from './confirm-send-dialog.component.service';
import { EmailDigest } from '../../../tamalelibs/models/emaildigest.model';
import { EmailDigestService } from '../../../services/email-digest.service';
import { NotificationStyles } from '../../../widgets/notification/notification.model';
import { ToastService } from '../../../widgets/toast/toast.service';
import { StringLiteralsPipe } from '../../../pipes/translate.pipe';
import { AaclKeywordSearchOptions } from 'aacl-keyword-search';

@Component({
    selector: 'tam-confirm-send-dialog',
    templateUrl: './confirm-send-dialog.component.html',
    styleUrls: ['./confirm-send-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmSendDialogComponent implements OnInit, OnDestroy {
    //#region public properties
    dialogOpened = false;
    emailDigest: EmailDigest;
    isSaving = false;
    isAddShow = false;
    keywordSearchOptionsUser: AaclKeywordSearchOptions = new AaclKeywordSearchOptions('', 0, ' ');
    keywordUser = '';
    recipientList = new Array<any>();
    userList = new Array<any>();
    allUsersAndTeams = new Array<any>();
    customRecipients = new Array<string>();

    /**
    * the subscription array that would be unsubscribed on destroying.
    */
    private _destroySubscriptions: Array<Subscription> = [];

    //#endregion

    constructor(private _changeDetectorRef: ChangeDetectorRef,
        private _emailDigestService: EmailDigestService,
        private _element: ElementRef,
        private _storeQuerier: StoreQuerierService,
        private _toast: ToastService,
        private _confirmSendDialogService: ConfirmSendDialogService,

    ) { }

    //#region public methods

    ngOnInit() {
        this._destroySubscriptions.push(this.keywordSearchOptionsUser.feedbackSubject$.subscribe(
            feedback => {
                this.keywordUser = feedback.payload.data;
                this._changeDetectorRef.detectChanges();
            }
        ));

        this._destroySubscriptions.push(
            this._confirmSendDialogService.dialogOpen$.pipe(
                filter(action => !this.dialogOpened),
            ).subscribe((emailDigest: EmailDigest) => {
                this.emailDigest = emailDigest;
                this.dialogOpened = true;
                this.allUsersAndTeams = this._storeQuerier.queryBySelector(usersAndTeamsSelector);
                this.recipientList = this.allUsersAndTeams.filter(item => emailDigest.recipients.includes(item.id));
                this.userList = this.allUsersAndTeams.filter(item => !(emailDigest.recipients.includes(item.id)));
                this._changeDetectorRef.detectChanges();

            }),
        );


    }

    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
        this._destroySubscriptions = [];
    }

    clickCancel() {
        this.dialogOpened = false;
        this.isAddShow = false;
    }
    clickAddRecipient($event) {
        this.isAddShow = !this.isAddShow;
        this.keywordUser = '';
        setTimeout(() => {
            if (this._element && this.isAddShow) {
                this._element.nativeElement.querySelector('.aacl-keyword-search-container .input-area input').focus();
            }
        });
    }
    clickSaveEmailDigest() {
        this._sendEmailDigest();
    }
    clickDelete(user) {
        this.recipientList = this.recipientList.filter(item => item.id !== user.id);
        this.userList = this.allUsersAndTeams.filter(item => !(this.recipientList.includes(item)));
        this._changeDetectorRef.detectChanges();
    }
    onUserClick(user) {
        this.isAddShow = false;
        this.keywordUser = '';
        this.userList = this.userList.filter(item => item.id !== user.id);
        this.recipientList.push(user);
        this._changeDetectorRef.detectChanges();
    }

    /**
     * send email digest
     */
    private _sendEmailDigest() {
        this.isSaving = true;
        if (this.customRecipients.length > 0) {
            this.customRecipients.splice(0, this.customRecipients.length);
        }
        this.recipientList.forEach(item => {
            this.customRecipients.push(item.id);
        });
        this._emailDigestService.sendEmail(this.emailDigest.id, this.customRecipients).pipe(
            catchError(e => {
                this.isSaving = false;
                this._toast.notify({
                    style: NotificationStyles.Error,
                    message: StringLiteralsPipe.translate('emailDigest.send_email_failed_error', e.message),
                });
                this._changeDetectorRef.detectChanges();
                return of(null);
            }),
            take(1),
        ).subscribe(result => {
            this.isSaving = false;
            if (result) {
                this.dialogOpened = false;
                if (result.result) {
                    this._toast.notify({
                        style: NotificationStyles.Success,
                        message: StringLiteralsPipe.translate('emailDigest.the_email_with_digest_name', this.emailDigest.name),
                    });
                } else {
                    this._toast.notify({
                        style: NotificationStyles.Error,
                        message: StringLiteralsPipe.translate('emailDigest.send_email_failed'),
                    });
                }
            }
            this._changeDetectorRef.detectChanges();
        });
    }
}
